"use strict";
exports.__esModule = true;
var react_1 = require("@chakra-ui/react");
var ui_common_1 = require("@codametrix/ui-common");
exports["default"] = (0, react_1.extendTheme)(ui_common_1.theme, {
    useSystemColorMode: false
});
//# sourceMappingURL=theme.js.map